import React, { Fragment, useEffect, useState } from 'react';
import numeral from 'numeral';

import { useTranslation } from 'react-i18next/hooks';

import Backdrop from '../../../Backdrop/Backdrop';
import GroupTalkTextFileKuraPreview from './GroupTalkTextFileKuraPreview';
import Img from "react-cool-img";
import SmallModal from '../../../Modal/SmallModal';
import Loader from '../../../Loader/Loader';

import { useStore } from '../../../../hook-store/store';
import { 
  getOriginalFileNameFromKey,
} from '../../../../util/bucket/bucket-object-util';
// import { 
//   getKuraBucketFileSignedUrl,
// } from '../../../../util/group/kura-bucket-file';

// import { isImageFile, isVideoFile, isAudioFile } from '../../../util/image';
// import { SOCKET_GROUP_URL } from '../../../App';
import { SOCKET_GROUP_URL } from '../../../../App';

import { marks } from '../../../../images/marks';
import classes from './GroupTalkTextFileKura.module.css';
// import './VideoTextTalk.css'




const GroupKuraFileIcon = (props) => {
  // console.log('VideoTextTalkTextFile.js props', props);
  const {
    inputData,
    showSepImage,
    setShowSepImage,
    isDownLoading,
    setShowSepImageHandler,
    fileUrl,
    errorMessage,
    kuraFileIconRef,
  } = props;
  
  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { 
    selectedKuraFileData,
    isGroupMember,
    userGetGroupKuraFileDataList,
   } = store.groupStore;
  const {
    isAuth,
  } = store.uiStore;


  const kuraFileInfo = inputData.kuraFileInfo;
  
  let kuraFileImageUrl;
  let isNotFoundError = false;
  let foundKuraFileData;

  if (userGetGroupKuraFileDataList && userGetGroupKuraFileDataList.length > 0) {
    const roomFileData = userGetGroupKuraFileDataList.find(element => {
      return element.groupRoomId === inputData.groupRoomId;
    });
  
    if (roomFileData) {
      const fileList = roomFileData.files;

      // console.log('fileList', fileList)
  
      if (fileList && fileList.length > 0 && kuraFileInfo) {
        const fileData = fileList.find(ele => {
          return ele.kuraFileInfo.bucket === kuraFileInfo.bucket && 
            ele.kuraFileInfo.key === kuraFileInfo.key;
        });
  
        // // console.log(fileData)
        if (fileData) {
          foundKuraFileData = fileData;
          // console.log('fileData', fileData);
          if (fileData.url) {
            kuraFileImageUrl = fileData.url;
          }
          if (fileData.smallImageUrl) {
            kuraFileImageUrl = fileData.smallImageUrl;
          }
          
          if (fileData.isNotFoundError) {
            isNotFoundError = true;
          }
        }
      }
    }
  }



  // console.log('foundKuraFileData', foundKuraFileData)

  let kuraFileBody;

  let canPreview = false;

  // console.log(kuraFileInfo)

  if (isGroupMember && (kuraFileInfo.mimeType?.split('/')[0] === 'image' ||
      kuraFileInfo.mimeType?.split('/')[0] === 'audio' ||
      kuraFileInfo.mimeType?.split('/')[0] === 'video')
  ) {
    canPreview = true;
  }

  if (kuraFileInfo.mimeType?.split('/')[0] === 'image' && (
        inputData.fileUrls?.length > 0
  )) {
    kuraFileBody = (
      <div>
        <div 
        // className={classes.textTalkFileKuraIcon}
        >
          <span
            ref={kuraFileIconRef}
            onClick={() => { 
              setShowSepImageHandler(!showSepImage);
            }}
          >
            <Img
              className={classes.textTalkFileKuraImage}
              src={inputData.fileUrls[0]}
            />
          </span>
        </div>
      </div>
    );
  } else {

    kuraFileBody = (
      <div>
        <div>
          {isDownLoading && (
            <span>
              <Loader />
            </span>
          )}
          {!isDownLoading && !isNotFoundError && kuraFileImageUrl && (
            <span className={classes.textTalkFileKuraIcon}
              ref={kuraFileIconRef}
              onClick={() => { 
                setShowSepImageHandler(!showSepImage);
              }}
            >
              <Img 
                className={classes.textTalkFileKuraImage}
                src={kuraFileImageUrl}
              />
            </span>
          )}
          {!isDownLoading && isNotFoundError && (
            <div className={classes.textTalkFileKuraNotFound}
            >
              <div className={classes.textTalkFileKuraNotFoundIcon}>
                <span
                  ref={kuraFileIconRef}
                  onClick={() => { 
                    setShowSepImageHandler(!showSepImage);
                  }}
                >
                  {/* <img 
                    className={classes.textTalkFileKuraImage}
                    src={"http://xxxyyy.com/xxx"}
                  /> */}
                  {marks.fileImage}
                </span>
              </div>
              <div>
                {t("groupTalk.text111", "file not found")}
              </div>
              <div>
                {t("groupTalk.text112", "file maybe deleted")}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (kuraFileInfo.mimeType?.split('/')[0] === 'video') {
    kuraFileBody = (
      <div>
        {isDownLoading && (
          <span>
            <Loader />
          </span>
        )}
        {!isDownLoading && (
          <div>
            <span className={classes.textTalkFileKuraIcon}
              onClick={() => { 
                setShowSepImageHandler(!showSepImage);
              }}
            >
              {marks.fileVideo} 
            </span>
          </div>
        )}
        {!isDownLoading && isNotFoundError && (
          <div className={classes.textTalkFileKuraNotFound}>
            <div>
              {t("groupTalk.text111", "file not found")}
            </div>
            <div>
              {t("groupTalk.text112", "file maybe deleted")}
            </div>
          </div>
        )}
      </div>
    );
  }

  if (kuraFileInfo.mimeType?.split('/')[0] === 'audio') {
    kuraFileBody = (
      <div>
        {isDownLoading && (
          <span>
            <Loader />
          </span>
        )}
        {!isDownLoading && (
          <div>
            <span className={classes.textTalkFileKuraIcon}
              onClick={() => { 
                setShowSepImageHandler(!showSepImage);
              }}
            >
              {marks.fileAudio}
            </span>
          </div>
        )}
        {!isDownLoading && isNotFoundError && (
          <div className={classes.textTalkFileKuraNotFound}>
            <div>
              {t("groupTalk.text111", "file not found")}
            </div>
            <div>
              {t("groupTalk.text112", "file maybe deleted")}
            </div>
          </div>
        )}
      </div>
      
    );
  }

  if (kuraFileInfo.mimeType?.split('/')[0] !== 'video' &&
      kuraFileInfo.mimeType?.split('/')[0] !== 'audio' &&
      kuraFileInfo.mimeType?.split('/')[0] !== 'image'
  ) {
    kuraFileBody = (
      <div>
        <div>
          <span className={classes.textTalkFileKuraIconOther}>
            {marks.fileMark}
          </span>
        </div>
      </div>
      
    );
  }

  if (!isAuth) {
    kuraFileBody = (
      <div>
        <span className={classes.textTalkFileKuraIconOther}>
          {marks.fileMark}
        </span>
        <div>
          {/* (Login-is-required-to-access) */}
        </div>
      </div>
    );
  }




  return (
    <Fragment>
      {/* {inputData.sendAt + 1000*6*1 < Date.now() && (
        <div>temp-file-deleted</div>
      )} */}
      {kuraFileBody}
      {inputData.kuraFileInfo?.key && (
        <div className={classes.textTalkFileKuraSection}>
          <div>
            <div>
              {t("groupTalk.text72", "Uploaded file post")}
            </div>
            {' '}
            {!isGroupMember && (
              <span>
                ({t("groupTalk.text73", "User need to be group member to access this file.")})
              </span>
            )}
          </div>
          <div className={classes.textTalkFileKuraDescription}>
            {isGroupMember && foundKuraFileData && foundKuraFileData.foundKey && (
              <span>
                <div className={classes.textTalkFileKuraText}>
                  {/* {decodeURI(getOriginalFileNameFromKey(inputData.kuraFileInfo.key))} */}
                  <span>
                    {decodeURI(getOriginalFileNameFromKey(foundKuraFileData.foundKey))}
                  </span>
                </div>
                <div className={classes.textTalkFileKuraText}>
                  ({numeral(kuraFileInfo.size).format('0.0 b')})
                </div>
              </span>
            )}
            {/* {canPreview && (
              <div className={classes.textTalkFileKuraText}>
                <span
                  onClick={() => {
                    setShowSepImageHandler(!showSepImage);
                  }}
                >
                  ({t("groupTalk.text74", "preview file")})
                </span>
              </div>
            )} */}
            {/* <div>file-more-data...</div> */}
          </div>
        </div>
      )}
      {showSepImage && (
            <div>
            <Backdrop 
              onClick={() => { 
                setShowSepImage(!showSepImage); 
              }}
            />
            <SmallModal>
              <GroupTalkTextFileKuraPreview 
                inputData={inputData}
                setShowSepImageHandler={setShowSepImageHandler}
                fileUrl={fileUrl}
                isDownLoading={isDownLoading}
                errorMessage={errorMessage}
                // getKuraFileSignedUrlHandler={getKuraFileSignedUrlHandler}
              />
            </SmallModal>
          </div>
      )}
    </Fragment>
  );
};

export default GroupKuraFileIcon;